import { AgreementStatus } from "../../types/Agreement";

export const agreementStatuses: { [key in AgreementStatus]: string } = {
  IN_PROGRESS: "En progreso",
  FINISHED: "Finalizado"
};
